<div id="header-user-menu-id" #headerUserMenu class="header-user-menu"
     [ngClass]="(isImpersonated | async) ? 'impersonated': ''" *ngIf="profileLoaded && profile !== null"
     (click)="openCloseUserMenu()">
    <ng-container *ngIf="!(isImpersonated | async); else impersonated">
        <div class="identicon">
            <aa-avatar-icon [src]="profile.identiconDataUrl" [alt]="profile.firstLastName" [size]="'48px'"
                            [withBg]="false">
            </aa-avatar-icon>
        </div>
        <div class="header-user-infos">
            <span class="firstLastName">{{ profile.firstLastName }}</span><br />
            <div class="profile-title">
                {{ profile.title }}
            </div>
            <i class="fas angle-user-menu" [ngClass]="{ 'fa-angle-down': !menuOpened, 'fa-angle-up': menuOpened }"
               aria-hidden="true"></i>
        </div>
    </ng-container>
    <ng-template #impersonated>
        <div class="identicon">
            <aa-avatar-icon [src]="profile.identiconDataUrl" [alt]="profile.firstLastName" [size]="'48px'"
                            [withBg]="false">
            </aa-avatar-icon>
        </div>
        <div class="header-user-infos">
            <span class="firstLastName">{{ profile.firstLastName }}</span>
            <br />
            <div class="profile-title">
                {{ impersonation.email }}<br />({{impersonation.entityShortId}})
            </div>
        </div>
    </ng-template>
</div>
<div class="aa-color-primary-normal aa-medium-current-text" *ngIf="!profileLoaded">
    <div class="avatar">
        <aa-avatar-icon [src]="'./assets/images/AurorA.png'" [alt]="'AurorA'" [size]="'48px'"></aa-avatar-icon>
    </div>
</div>
